<template>
  <div id="dcCarbonApp">
    <div class="mainWrapper">
      <div id="translationsForPoFiles" style="display: none">
        <translate>Country CO2 / kWh</translate>
        <translate>Total</translate>
        <span class="unitCO2eq">kg CO<sub>2</sub>eq</span>
        <translate>Savings</translate>
        <span class="unitCO2eq">kg CO<sub>2</sub>eq</span>
        <translate>generated during production of pipe and production of raw material</translate>
      </div>
      <!--    <Multiselect id="unit" ref="selectUnits" @changeSelect="calcResult"></Multiselect>-->
      <div class="halfRow" style="width: 44%">
        <div class="row" style="margin-top: 4px">
          <div class="ddWrapper withborder">
            <translate>Plastic Pipe</translate>
            <Multiselect id="selectMaterialPlastic" ref="selectMaterialPlastic"
                         @changeSelect="onChangeMaterialPlastic"></Multiselect>
<!--            <div style="margin-top:10px"><translate>Pipe Dimension</translate></div>-->
<!--            <Multiselect id="selectPlasticDimension" ref="selectPlasticDimension"-->
<!--                         @changeSelect="onChangePlasticDimension"></Multiselect>-->
          </div>
          <div class="ddWrapper withborder">
            <translate>Metal Pipe</translate>
            <Multiselect id="selectMaterialMetal" ref="selectMaterialMetal"
                         @changeSelect="onChangeMaterialMetal"></Multiselect>
<!--            <div style="margin-top:10px"><translate>Pipe Dimension</translate></div>-->
<!--            <Multiselect id="selectMetalDimension" ref="selectMetalDimension"-->
<!--                         @changeSelect="calcResult"></Multiselect>-->
          </div>
          <br>
          <div class="ddWrapper countryCO2" style="margin-top: 30px">
            <span v-translate render-html="true">Country CO2 / kWh</span>
            <Multiselect id="selectCountryCO2" ref="selectCountryCO2" @changeSelect="calcResult"></Multiselect>
          </div>
<!--          <br>-->
          <div class="ddWrapper" style="margin-top: 30px">
            <translate>Units</translate>
            <Multiselect id="selectUnits" ref="selectUnits" @changeSelect="onChangeMaterialMetal"></Multiselect>
          </div>

        </div>
        <div class="row">
          <div class="resultList" ref="resultList">
            <div id="pipesList" class="pipesList" ref="pipesList">

            </div>
            <span class="bAddPipe" @click="onAddPipe"><translate>Add Pipe</translate></span>
          </div>
          <br>
          <div class="ddWrapper" style="margin-bottom: 40px">
            <div class="resetDiv" style="cursor:pointer; color:#00afff" @click="doReset">
              <translate>Reset All</translate>
            </div>
          </div>
        </div>
      </div>
      <div class="halfRow">
        <div class="resultInfo">
          <div class="row">
            <h3><span v-translate render-html="true">Total</span> <span class="unitCO2eq">kg CO<sub>2</sub>eq</span>&nbsp;
              <span v-translate render-html="true">Savings</span></h3>
            <div class="col50">
              <div class="row" style="margin-bottom: 10px">
                <span class="unitCO2eq">kg CO<sub>2</sub>eq</span> <span v-translate render-html="true">generated during production of pipe and production of raw material</span>
              </div>
              <table style="width: 100%">
                <tr>
                  <td style="width:50%">
                    <p style="margin-top:0" class="resultMaterialHeader resultMaterialPlastic">
                      <translate>Plastic Pipe</translate>
                    </p>

                  </td>
                  <td>
                    <p style="margin-top:0" class="resultMaterialHeader">
                      <translate>Metal Pipe</translate>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style="width:50%">
                    <p class="resultName" id="namePlastic"></p>

                  </td>
                  <td>
                    <p class="resultName" id="nameMetal"></p>
                  </td>
                </tr>
                <tr>
                  <td style="width:50%">
                    <p class="resultName" id="namePlasticDimension"></p>

                  </td>
                  <td>
                    <p class="resultName" id="nameMetalDimension"></p>
                  </td>
                </tr>
                <tr>
                  <td style="width:50%">
                    <div id="resultPlastic" class="countResult">0</div>

                  </td>
                  <td>
                    <div id="resultMetal" class="countResult">0</div>
                  </td>
                </tr>
              </table>
              <!--            <div class="col50" >-->
              <!--              <p style="margin-top:0" class="resultMaterialHeader"><translate>Metal Pipe</translate></p>-->
              <!--              <p class="resultName" id="nameMetal"></p>-->
              <!--              <div id="resultMetal" class="countResult">0</div>-->
              <!--            </div>-->
              <!--            <div class="col50">-->
              <!--              <p style="margin-top:0" class="resultMaterialHeader resultMaterialPlastic"><translate>Plastic Pipe</translate></p>-->
              <!--              <p class="resultName" id="namePlastic"></p>-->
              <!--              <div id="resultPlastic" class="countResult">0</div>-->
              <!--            </div>-->
            </div>
          </div>
          <div class="row">
            <div class="col50">
              <span>&nbsp;</span>
              <div class="badge badgeCO2">
                <div class="badgeHeader"><span v-translate render-html="true">Total</span>&nbsp;<span class="unitCO2eq">kg CO<sub>2</sub>eq</span>&nbsp;<span
                    v-translate render-html="true">Savings</span><img class="infoI" src="../assets/icon_info.png"
                                                                      v-tooltip.right="{ ref: 'refTooltipCO2Savings' }">
                </div>
                <div ref="refTooltipCO2Savings" class="tooltip-content">
                  <translate>Tooltip CO2 savings</translate>
                </div>
                <div class="badgeNumber"><span id="countCO2Savings">0</span></div>
              </div>
            </div>
            <br>
            <div class="col50">
              <div class="blueBadgeHeader" style="margin-top: 16px"><strong>
                <translate>Savings Equivalent</translate>
              </strong></div>
              <div class="badge badgeCar blueBadge">
                <div class="badgeHeader"><span class="unitKm">Km</span>&nbsp;<translate> travelled by car</translate>
                  <img class="infoI" src="../assets/icon_info.png" v-tooltip.right="{ ref: 'refTooltipCar' }"></div>
                <div ref="refTooltipCar" class="tooltip-content">
                  <translate>1 passenger</translate>
                </div>
                <div class="badgeNumber"><span id="countCar">0</span></div>
              </div>
              <div class="blueBadgeHeader">
                <translate>or</translate>
              </div>
              <div class="badge badgePlane blueBadge">
                <div class="badgeHeader"><span class="unitKm">Km</span>&nbsp;<translate> travelled by plane</translate>
                  <img class="infoI" src="../assets/icon_info.png" v-tooltip.right="{ ref: 'refTooltipPlane' }"></div>
                <div ref="refTooltipPlane" class="tooltip-content">
                  <translate>per passenger</translate>
                </div>
                <div class="badgeNumber"><span id="countPlane">0</span></div>
              </div>
              <div class="blueBadgeHeader">
                <translate>or</translate>
              </div>
              <div class="badge badgeLeaf blueBadge">
                <div class="badgeHeader">
                  <translate>Planted trees</translate>
                  <img class="infoI" src="../assets/icon_info.png" v-tooltip.right="{ ref: 'refTooltipTrees' }"></div>
                <div ref="refTooltipTrees" class="tooltip-content">
                  <translate>Tooltip Trees</translate>
                </div>
                <div class="badgeNumber"><span id="countTrees">0</span></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div style="display: none">
        <img id="imgPapierkorb" onclick="deletePipe(this)" class="papierkorb" src="../assets/papierkorb.png">
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import Multiselect from "@/components/Multiselect";
import $ from 'jquery';

require("../assets/papierkorb.png");
/* eslint-disable */
var pipeListCounter = 0;
var pipeListInstances = [];
var pipeListInstancesMetal = [];
window.pipeListInstances = pipeListInstances;
window.pipeListInstancesMetal = pipeListInstancesMetal;
let dims = ['d25 / DN20',
  'd32 / DN25',
  'd40 / DN32',
  'd50 / DN40',
  'd63 / DN50',
  'd75 / DN63',
  'd90 / DN80',
  'd110 / DN100',
  'd125 / DN110',
  'd160 / DN150',
  'd225 / DN200',
  'd250 / DN225',
  'd315 / DN250',
  'd355 / DN300',
  'd400 / DN350',
  'd450 / DN400',
  'd500 / DN450',
  'd560 / DN500',
  'd630 / DN560',
  'd710 / DN600',
  'd800 / DN710',
  'd900 / DN800',
  'd1000 / DN900',
];
let dimsImperial = ['3/4"',
  '1"',
  '1 1/4"',
  '1 1/2"',
  '2"',
  '2 1/2"',
  '3"',
  '4"',
  '5"',
  '6"',
  '8"',
  0,
  '10"',
  '12"',
  '14"',
  '16"',
  '18"',
  '20"',
  '22"',
  '24"',
  0,
  '32"',

];
let values = [];
values["PE SDR11"] = [];
values["PE SDR11"][0] = [0.03633, 0.05922, 0.09114, 0.14133, 0.2226, 0.3108, 0.4494, 0.672, 0.8652, 1.005, 1.995, 2.445, 3.885, 4.935, 6.255, 7.92, 9.78, 12.225, 15.48, 19.4955, 24.42, 31.125, 39.195];
values["PE SDR11"][1] = [0.4077146014, 0.6645983676, 1.0228216012, 1.5860805014, 2.498135708, 3.487963064, 5.043406052, 7.54154176, 9.709735016, 15.79010306, 31.34453294, 38.468, 61.03935362, 77.53647622, 98.27571606, 124.43543904, 153.65891336, 192.0736417, 243.21472176, 306.304432046, 383.67593704, 489.0218485, 615.81401934];

values["PVC PN16"] = [];
values["PVC PN16"][0] = [0.0552, 0.0897, 0.1403, 0.2185, 0.345, 0.441, 0.651, 0.966, 1.239, 2.016, 3.99, 0, 7.77, 9.87, 12.6, 16.17, 0, 0, 0, 0, 0, 0, 0];
values["PVC PN16"][1] = [0.5592, 0.9087, 1.4213, 2.2135, 3.495, 4.893, 7.223, 10.718, 13.747, 22.368, 44.27, 0, 86.21, 109.51, 139.8, 179.41, 0, 0, 0, 0, 0, 0, 0];

values["PE SDR17"] = [];
values["PE SDR17"][0] = [0, 0.0399, 0.0609, 0.0945, 0.1491, 0.2121, 0.3045, 0.4515, 0.5754, 0.675, 1.335, 1.6365, 2.6025, 3.3135, 4.1865, 5.304, 6.603, 8.211, 10.3995, 13.2, 16.7325, 21.1665, 26.1585];
values["PE SDR17"][1] = [0, 0.4484, 0.6844, 1.062, 1.6756, 2.3836, 3.422, 5.074, 6.4664, 10.62, 21.004, 25.7476, 40.946, 52.1324, 65.8676, 83.4496, 103.8872, 129.1864, 163.6188, 207.68, 263.258, 333.0196, 411.5604];

values["PVC Sch.80"] = [];
values["PVC Sch.80"][0] = [0.0281680632, 0.0427737256, 0.0542496032, 0.0698985272, 0.099109852, 0.138118764, 0.1847933808, 0.26194938, 0.3686342184, 0.5162784144, 0.766797276, 0, 1.14305184, 1.57169628, 1.838408376, 2.4232699008, 3.0319450056, 3.819698232, 0, 5.4180657216, 0, 0, 0];
values["PVC Sch.80"][1] = [0.2853547272, 0.4333164376, 0.5495720672, 0.7081024712, 1.004025892, 1.532460572, 2.0503265584, 2.90639074, 4.0900844232, 5.7282319312, 8.507798348, 0, 12.68243232, 17.43834444, 20.397578648, 26.8867565184, 33.6401517288, 42.380461336, 0, 60.1147291968, 0, 0, 0];

values["PP-H SDR11"] = [];
values["PP-H SDR11"][0] = [0.03633, 0.05922,0.09114,0.14133,0.2226,0.3108,0.4494,0.672,0.8652,1.407,2.793,0,0,0,0,0,0,0,0,0,0,0,0];
values["PP-H SDR11"][1] = [0.4077146014,0.6645983676,1.0228216012,1.5860805014,2.498135708,3.487963064,5.043406052,7.54154176,9.709735016,15.79010306,31.34453294,38.468,61.03935362,77.53647622,98.27571606,124.43543904,153.65891336,192.0736417,243.21472176,306.304432046,383.67593704,489.0218485,615.81401934
];

values["Carbon Steel"] = [];
values["Carbon Steel"][0] = [0.26134416, 0.388905, 0.52579956, 0.62847048, 0.84470166, 1.34094444, 1.75318374, 2.5696, 3.4784, 4.5168, 6.7984, 0, 9.6384, 12.752, 15, 19.68, 24.96, 29.28, 0, 40.8, 0, 54.72, 0];
values["Carbon Steel"][1] = [2.49608772, 3.71441625, 5.02189077, 6.00249666, 8.067712095, 12.80730723, 16.744588455, 23.86140999, 32.30056371, 41.943188295, 63.130218585, 0, 89.50257396, 118.41559005, 139.290609375, 182.7492795, 231.779574, 271.8952695, 0, 378.8704575, 0, 508.132143, 0];

values["Stainless Steel"] = [];
values["Stainless Steel"][0] = [0.2688, 0.4, 0.5424, 0.6496, 0.872, 1.3824, 1.808, 2.576, 3.488, 4.528, 6.8, 0, 9.664, 11.824, 0, 0, 0, 0, 0, 0, 0, 0, 0];
values["Stainless Steel"][1] = [7.7112, 11.475, 15.5601, 18.6354, 25.0155, 39.6576, 51.867, 73.899, 100.062, 129.897, 195.075, 0, 277.236, 339.201, 0, 0, 0, 0, 0, 0, 0, 0, 0];

values["Stainless Thin Walled"] = [];
values["Stainless Thin Walled"][0] = [0, 0, 0, 0, 0.416, 0.5408, 0.6576, 0.8176, 1.0176, 1.2176, 1.6192, 0, 2.0192, 2.4192, 3.5312, 4.8432, 0, 6.0448, 0, 7.2464, 0, 0, 0];
values["Stainless Thin Walled"][1] = [0, 0, 0, 0, 11.934, 15.5142, 18.8649, 23.4549, 29.1924, 34.9299, 46.4508, 0, 57.9258, 69.4008, 101.3013, 138.9393, 0, 173.4102, 0, 207.8811, 0, 0, 0];

values["Stainless Sch10 ASTM 312"] = [];
values["Stainless Sch10 ASTM 312"][0] = [0.208, 0.3408, 0.432, 0.5056, 0.6384, 0.8544, 1.0496, 1.36, 1.8784, 2.2464, 3.24, 0, 4.512, 5.76, 6.608, 7.5664, 8.5472, 10.9936, 0, 15.112, 0, 0, 0];
values["Stainless Sch10 ASTM 312"][1] = [5.967, 9.7767, 12.393, 14.5044, 18.3141, 24.5106, 30.1104, 39.015, 53.8866, 64.4436, 92.9475, 0, 129.438, 165.24, 189.567, 217.0611, 245.1978, 315.3789, 0, 433.5255, 0, 0, 0];

values["Copper"] = [];
values["Copper"][0] = [0.31009888, 0.44640608, 0.602477824, 0.77695104, 1.192688, 1.69020928, 2.26951488, 3.66666368, 5.18648896, 6.9516672, 13.1536448, 0, 20.5142336, 27.5340544, 0, 0, 0, 0, 0, 0, 0, 0, 0];
values["Copper"][1] = [1.23365424, 1.77591984, 2.396813952, 3.09091392, 4.744824, 6.72409344, 9.02872224, 14.58694464, 20.63320608, 27.6555456, 52.3286304, 0, 81.6109728, 109.5376512, 0, 0, 0, 0, 0, 0, 0, 0, 0];


var timeoutcountCO2Savings, timeoutcountCar, timeoutcountPlane, timeoutcountTrees;
var that;

function animateCount(spanID, currentNumber, countTo) {
  countTo = parseInt(countTo);
  currentNumber = parseInt(parseLocaleNumber($("#" + spanID).text(), window.mylang));
  if (currentNumber > countTo) {
    currentNumber -= Math.ceil(Math.abs(currentNumber - countTo) / 18);
  } else if (currentNumber < countTo) {
    currentNumber += Math.ceil(Math.abs(currentNumber - countTo) / 18);
  }
  $("#" + spanID).text(that.formatNumber(currentNumber));
  if (currentNumber != countTo) {
    clearTimeout(window["timeout" + spanID]);
    window["timeout" + spanID] = setTimeout(function () {
      animateCount(spanID, currentNumber, countTo)
    }, (90 - Math.abs(currentNumber - countTo)));
  }
}

window.parseLocaleNumber = function (stringNumber, locale) {
  var thousandSeparator = Intl.NumberFormat(locale).format(11111).replace(/\p{Number}/gu, '');
  var decimalSeparator = Intl.NumberFormat(locale).format(1.1).replace(/\p{Number}/gu, '');

  return parseFloat(stringNumber
      .replace(new RegExp('\\' + thousandSeparator, 'g'), '')
      .replace(new RegExp('\\' + decimalSeparator), '.')
  );
}
window.deletePipe = function (item) {
  $(item).parent().remove();
  that.calcResult();
}
export default {
  name: "DcCarbonCalculator",
  components: {Multiselect},
  created: function () {
    that = this;
    window.that = this;
    setTimeout(that.init, 4);
  },
  methods: {
    init() {

      let options = [
        // {label:window.myvm.$gettext("Please select"), value:-1},
        {label: window.myvm.$gettext("PE SDR11"), value: "PE SDR11"},
        {label: window.myvm.$gettext("PE SDR17"), value: "PE SDR17"},
        {label: window.myvm.$gettext("PVC mm PN16"), value: "PVC PN16"},
        {label: window.myvm.$gettext("PVC Sch.80"), value: "PVC Sch.80"},
        {label: window.myvm.$gettext("PP-H SDR11"), value: "PP-H SDR11"},
      ];
      that.$refs.selectMaterialPlastic.setOptions(options);
      that.$refs.selectMaterialPlastic.setPlaceholder(window.myvm.$gettext("Please select"));

      options = [
        // {label:window.myvm.$gettext("Please select"), value:-1},
        {label: window.myvm.$gettext("Carbon Steel Sch40"), value: "Carbon Steel"},
        {label: window.myvm.$gettext("Stainless ASTM Sch 40"), value: "Stainless Steel"},
        {label: window.myvm.$gettext("Stainless Thin Walled"), value: "Stainless Thin Walled"},
        {label: window.myvm.$gettext("Stainless ASTM Sch 10"), value: "Stainless Sch10 ASTM 312"},
        {label: window.myvm.$gettext("Copper L"), value: "Copper"},
      ];
      that.$refs.selectMaterialMetal.setOptions(options);
      that.$refs.selectMaterialMetal.setPlaceholder(window.myvm.$gettext("Please select"));


      options = [
        // {label:window.myvm.$gettext("Please select"), value:-1},
        {label: window.myvm.$gettext("CH") + " - 0.058", value: 0.058},
        {label: window.myvm.$gettext("D") + " - 0.352", value: 0.352},
        {label: window.myvm.$gettext("UK") + " - 0.265", value: 0.265},
        {label: window.myvm.$gettext("Ireland") + " - 0.381", value: 0.381},
        {label: window.myvm.$gettext("Denmark") + " - 0.15", value: 0.15},
        {label: window.myvm.$gettext("Finnland") + " - 0.069", value: 0.069},
        {label: window.myvm.$gettext("Sweden") + " - 0.012", value: 0.012},
        {label: window.myvm.$gettext("Norway") + " - 0.025", value: 0.025},
        {label: window.myvm.$gettext("USA") + " - 0.357", value: 0.357},
        {label: window.myvm.$gettext("Australia") + " - 0.486", value: 0.486},
        {label: window.myvm.$gettext("Japan") + " - 0.416", value: 0.416},
        {label: window.myvm.$gettext("Taiwan") + " - 0.567", value: 0.567},
        {label: window.myvm.$gettext("Indonesia") + " - 0.625", value: 0.625},
        {label: window.myvm.$gettext("Malaysia") + " - 0.541", value: 0.541000001},
        {label: window.myvm.$gettext("China") + " - 0.541", value: 0.541},
        {label: window.myvm.$gettext("Singapore") + " - 0.464", value: 0.464},
        {label: window.myvm.$gettext("Spain") + " - 0.169", value: 0.169},
        {label: window.myvm.$gettext("Italy") + " - 0.223", value: 0.223},
        {label: window.myvm.$gettext("France") + " - 0.058", value: 0.058000001},
        {label: window.myvm.$gettext("Thailand") + " - 0.475", value: 0.475},
        {label: window.myvm.$gettext("Vietnam") + " - 0.475", value: 0.475000001},
        {label: window.myvm.$gettext("Philipinnes") + " - 0.555", value: 0.555},
      ];
      that.$refs.selectCountryCO2.setOptions(options);
      that.$refs.selectCountryCO2.setPlaceholder(window.myvm.$gettext("Please select"));

      options = [
        // {label:window.myvm.$gettext("Please select"), value:-1},
        {label: window.myvm.$gettext("metric"), value: "metric"},
        {label: window.myvm.$gettext("Imperial"), value: "imperial"},
      ];
      that.$refs.selectUnits.setOptions(options);
      that.$refs.selectUnits.setSelectedIndex(0);


      // that.$refs.selectPlasticDimension.setOptions([
      //   {label: window.myvm.$gettext('d25 / DN20'), value: 0},
      //   {label: window.myvm.$gettext('d32 / DN25'), value: 1},
      //   {label: window.myvm.$gettext('d40 / DN32'), value: 2},
      //   {label: window.myvm.$gettext('d50 / DN40'), value: 3},
      //   {label: window.myvm.$gettext('d63 / DN50'), value: 4},
      //   {label: window.myvm.$gettext('d75 / DN63'), value: 5},
      //   {label: window.myvm.$gettext('d90 / DN80'), value: 6},
      //   {label: window.myvm.$gettext('d110 / DN100'), value: 7},
      //   {label: window.myvm.$gettext('d125 / DN110'), value: 8},
      //   {label: window.myvm.$gettext('d160 / DN150'), value: 9},
      //   {label: window.myvm.$gettext('d225 / DN200'), value: 10},
      //   {label: window.myvm.$gettext('d250 / DN225'), value: 11},
      //   {label: window.myvm.$gettext('d315 / DN250'), value: 12},
      //   {label: window.myvm.$gettext('d355 / DN300'), value: 13},
      //   {label: window.myvm.$gettext('d400 / DN350'), value: 14},
      //   {label: window.myvm.$gettext('d450 / DN400'), value: 15},
      //   {label: window.myvm.$gettext('d500 / DN450'), value: 16},
      //   {label: window.myvm.$gettext('d560 / DN500'), value: 17},
      //   {label: window.myvm.$gettext('d630 / DN560'), value: 18},
      //   {label: window.myvm.$gettext('d710 / DN600'), value: 19},
      //   {label: window.myvm.$gettext('d800 / DN710'), value: 20},
      //   {label: window.myvm.$gettext('d900 / DN800'), value: 21},
      //   {label: window.myvm.$gettext('d1000 / DN900'), value: 22},
      // ]);
      //
      // that.$refs.selectMetalDimension.setOptions([
      //   {label: window.myvm.$gettext('3/4"'), value: 0},
      //   {label: window.myvm.$gettext('1"'), value: 1},
      //   {label: window.myvm.$gettext('1 1/4"'), value: 2},
      //   {label: window.myvm.$gettext('1 1/2"'), value: 3},
      //   {label: window.myvm.$gettext('2"'), value: 4},
      //   {label: window.myvm.$gettext('2 1/2"'), value: 5},
      //   {label: window.myvm.$gettext('3"'), value: 6},
      //   {label: window.myvm.$gettext('4"'), value: 7},
      //   {label: window.myvm.$gettext('5"'), value: 8},
      //   {label: window.myvm.$gettext('6"'), value: 9},
      //   {label: window.myvm.$gettext('8"'), value: 10},
      //   // {label: window.myvm.$gettext('0'), value: 11},
      //   {label: window.myvm.$gettext('10"'), value: 12},
      //   {label: window.myvm.$gettext('12"'), value: 13},
      //   {label: window.myvm.$gettext('14"'), value: 14},
      //   {label: window.myvm.$gettext('16"'), value: 15},
      //   {label: window.myvm.$gettext('18"'), value: 16},
      //   {label: window.myvm.$gettext('20"'), value: 17},
      //   {label: window.myvm.$gettext('22"'), value: 18},
      //   {label: window.myvm.$gettext('24"'), value: 19},
      //   // {label: window.myvm.$gettext('0'), value: 20},
      //   {label: window.myvm.$gettext('32"'), value: 21},
      //   // {label: window.myvm.$gettext('d1000 / DN900'), value: 22},
      // ]);

      this.onAddPipe();
    },
    onChangeMaterialPlastic() {

      let dimsToAdd = [];
      let dim = dims;
      if (that.$refs.selectUnits.val() === "imperial") {
        dim = dimsImperial;
      }

      // let matMetal = that.$refs.selectMaterialMetal.val();
      let matPlastic = that.$refs.selectMaterialPlastic.val();
      for (var i = 0; i < dim.length; ++i) {
        // console.log(dims[i], values[matPlastic][0][i]  + " - " + values[matMetal][0][i]);

        if ((dim[i] != 0) && matPlastic === "" || values[matPlastic][0][i] != 0) {
          dimsToAdd.push({label: window.myvm.$gettext(dim[i]), value: i});
        }
      }
      // that.$refs.selectPlasticDimension.setOptions(dimsToAdd);
      for (var i = 0; i < window.pipeListInstances.length; ++i) {
        window.pipeListInstances[i].setOptions(dimsToAdd);
      }
      // if (that.$refs.selectPlasticDimension.val() == "") {
      //   that.$refs.selectPlasticDimension.setSelectedIndex(0);
      // }

      this.calcResult();
    },
    onChangePlasticDimension(me) {
      console.log(me);
      console.log(me.$el);
      console.log($(me.$el).attr("data-id"));
      // that.$refs.selectMetalDimension.setSelected(that.$refs.selectPlasticDimension.val());
      window.pipeListInstancesMetal[$(me.$el).attr("data-id")-1].setSelected(window.pipeListInstances[$(me.$el).attr("data-id")-1].val());
      this.calcResult();
    },
    onChangeMaterialMetal() {

      let dimsToAdd = [];
      let dim = dimsImperial;

      // dim = dimsImperial;
      let matMetal = that.$refs.selectMaterialMetal.val();
      // let matPlastic = that.$refs.selectMaterialPlastic.val();
      for (var i = 0; i < dim.length; ++i) {
        // console.log(dims[i], values[matPlastic][0][i]  + " - " + values[matMetal][0][i]);

        if ((dim[i] != 0) && ((matMetal === "" ) || values[matMetal][0][i] != 0 )) {
          dimsToAdd.push({label: window.myvm.$gettext(dim[i]), value: i});
        }
      }
      // console.log(dimsToAdd);
      // that.$refs.selectMetalDimension.setOptions(dimsToAdd);

      for (var i = 0; i < window.pipeListInstancesMetal.length; ++i) {
        window.pipeListInstancesMetal[i].setOptions(dimsToAdd);
        // if (window.pipeListInstancesMetal[i].val() == "") {
        //   window.pipeListInstancesMetal[i].setSelectedIndex(0);
        // }
      }

      // if (that.$refs.selectMetalDimension.val() == "") {
      //   that.$refs.selectMetalDimension.setSelectedIndex(0);
      // }

      if (that.$refs.selectUnits.val() !== "imperial") {
        dim = dims;
      }

      let matPlastic = that.$refs.selectMaterialPlastic.val();
      dimsToAdd = [];
      // let matPlastic = that.$refs.selectMaterialPlastic.val();
      for (var i = 0; i < dim.length; ++i) {
        // console.log(dims[i], values[matPlastic][0][i]  + " - " + values[matMetal][0][i]);

        if ((dim[i] != 0) && ((matPlastic === "" ) || values[matPlastic][0][i] != 0 )) {
          dimsToAdd.push({label: window.myvm.$gettext(dim[i]), value: i});
        }
      }
      // that.$refs.selectPlasticDimension.setOptions(dimsToAdd);
      for (var i = 0; i < window.pipeListInstances.length; ++i) {
        console.log("addplastic",window.pipeListInstances[i]);
        window.pipeListInstances[i].setOptions(dimsToAdd);
        // if (window.pipeListInstancesMetal[i].val() == "") {
        //   window.pipeListInstancesMetal[i].setSelectedIndex(0);
        // }
      }
      // console.log(that.$refs.selectPlasticDimension.index());
      // if (that.$refs.selectPlasticDimension.val() == "") {
      //   that.$refs.selectPlasticDimension.setSelectedIndex(0);
      // } else {
      //   that.$refs.selectPlasticDimension.setSelected(that.$refs.selectPlasticDimension.val());
      // }



      // for (var i = 0; i < window.pipeListInstances.length; ++i) {
      //   window.pipeListInstances[i].setOptions(dimsToAdd);
      //   if (window.pipeListInstances[i].val() == "") {
      //     window.pipeListInstances[i].setSelectedIndex(0);
      //   }
      // }

      this.calcResult();
    },
    calcResult() {
      if (that.$refs.selectUnits.val() === "metric") {
        $(".unitM").text(window.myvm.$gettext('m'));
        $(".unitKm").text(window.myvm.$gettext('Km'));
        $(".unitCO2eq").html(window.myvm.$gettext('kg CO2eq'));
      } else {
        $(".unitM").text(window.myvm.$gettext('feet'));
        $(".unitKm").text(window.myvm.$gettext('Miles'));
        $(".unitCO2eq").html(window.myvm.$gettext('lbs CO2eq'));
      }
      if (that.$refs.selectMaterialPlastic.val() === -1
          || that.$refs.selectMaterialMetal.val() === -1
          || that.$refs.selectCountryCO2.val() === -1
          || that.$refs.selectUnits.val() === -1
          || that.$refs.selectCountryCO2.val() === ""
      ) {
        return;
      }
      var tempAdd = 0;
      var totalPlastic = 0, totalMetal = 0, totalSavings = 0;
      var countryCO2 = that.$refs.selectCountryCO2.val();
      var materialPlastic = that.$refs.selectMaterialPlastic.val();
      var materialMetal = that.$refs.selectMaterialMetal.val();
      $("#nameMetal").text(that.$refs.selectMaterialMetal.label());
      // $("#nameMetalDimension").text(that.$refs.selectMetalDimension.label());
      $("#namePlastic").text(that.$refs.selectMaterialPlastic.label());
      // $("#namePlasticDimension").text(that.$refs.selectPlasticDimension.label());
      $(".pipeListItem").each(function () {
        var id = parseInt($(this).find(".selectPlasticDim").attr("data-id"));
        var length = parseInt($(this).find(".inputLength").val());
        var dimensionPlastic = window.pipeListInstances[id-1].val();
        var dimensionMetal = window.pipeListInstancesMetal[id-1].val();
        if (that.$refs.selectUnits.val() === "imperial") {
          length *= 0.3048; //feet 2 meter
        }
        if (materialPlastic != "") totalPlastic += (values[materialPlastic][1][dimensionPlastic] + (countryCO2 * values[materialPlastic][0][dimensionPlastic])) * length;
        if (materialMetal != "") totalMetal += (values[materialMetal][1][dimensionMetal] + (countryCO2 * values[materialMetal][0][dimensionMetal])) * length;

        $(this).find(".inputLength").val(parseInt($(this).find(".inputLength").val()))
      });

      totalSavings = Math.round(totalMetal - totalPlastic);
      totalPlastic = Math.round(totalPlastic);
      totalMetal = Math.round(totalMetal);

      if (that.$refs.selectUnits.val() === "imperial") {
        $("#resultMetal").text(that.formatNumber(Math.round(totalMetal * 2.2046)));
        $("#resultPlastic").text(that.formatNumber(Math.round(totalPlastic * 2.2046)));
        animateCount("countCO2Savings", 0, totalSavings * 2.2046);
      } else {
        $("#resultMetal").text(that.formatNumber(Math.round(totalMetal)));
        $("#resultPlastic").text(that.formatNumber(Math.round(totalPlastic)));
        animateCount("countCO2Savings", 0, totalSavings);
      }

      if (that.$refs.selectUnits.val() === "imperial") {
        animateCount("countCar", 0, Math.round((totalSavings / 0.1234) * 0.621371));
        animateCount("countPlane", 0, Math.round((totalSavings / 0.115) * 0.621371));
      } else {
        animateCount("countCar", 0, Math.round(totalSavings / 0.1234));
        animateCount("countPlane", 0, Math.round(totalSavings / 0.115));
      }

      animateCount("countTrees", 0, Math.round(totalSavings / 1000));
    },
    onChangeUnits() {
      console.log("CHANGE UNITS");
      let dimsToAdd = [];
      let dim = dims;
      if (that.$refs.selectUnits.val() === "imperial") {
        dim = dimsImperial;
      }
      let matMetal = that.$refs.selectMaterialMetal.val();
      let matPlastic = that.$refs.selectMaterialPlastic.val();

      // if (matPlastic != -1 && matMetal != -1) {
      //   for (var i = 0; i < dim.length; ++i) {
      //     // console.log(matPlastic);
      //     if (values[matMetal][0][i] != 0 && values[matPlastic][0][i] != 0) {
      //       dimsToAdd.push({label: window.myvm.$gettext(dim[i]), value: i});
      //     }
      //   }
      //
      //   for (var i = 0; i < window.pipeListInstances.length; ++i) {
      //     instance.setOptions(dimsToAdd);
      //   }
      // } else {
      //   if (that.$refs.selectMaterialMetal.val() != "Stainless Steel") {
      //     instance.setOptions([
      //       {label: window.myvm.$gettext('d25 / DN20'), value: 0},
      //       {label: window.myvm.$gettext('d32 / DN25'), value: 1},
      //       {label: window.myvm.$gettext('d40 / DN32'), value: 2},
      //       {label: window.myvm.$gettext('d50 / DN40'), value: 3},
      //       {label: window.myvm.$gettext('d63 / DN50'), value: 4},
      //       {label: window.myvm.$gettext('d75 / DN63'), value: 5},
      //       {label: window.myvm.$gettext('d90 / DN80'), value: 6},
      //       {label: window.myvm.$gettext('d110 / DN100'), value: 7},
      //       {label: window.myvm.$gettext('d125 / DN110'), value: 8},
      //       {label: window.myvm.$gettext('d160 / DN150'), value: 9},
      //       {label: window.myvm.$gettext('d225 / DN200'), value: 10},
      //       {label: window.myvm.$gettext('d250 / DN225'), value: 11},
      //       {label: window.myvm.$gettext('d315 / DN250'), value: 12},
      //       {label: window.myvm.$gettext('d355 / DN300'), value: 13},
      //       {label: window.myvm.$gettext('d400 / DN350'), value: 14},
      //       {label: window.myvm.$gettext('d450 / DN400'), value: 15},
      //       {label: window.myvm.$gettext('d500 / DN450'), value: 16},
      //       {label: window.myvm.$gettext('d560 / DN500'), value: 17},
      //       {label: window.myvm.$gettext('d630 / DN560'), value: 18},
      //       {label: window.myvm.$gettext('d710 / DN600'), value: 19},
      //       {label: window.myvm.$gettext('d800 / DN710'), value: 20},
      //       {label: window.myvm.$gettext('d900 / DN800'), value: 21},
      //       {label: window.myvm.$gettext('d1000 / DN900'), value: 22},
      //     ]);
      //   } else {
      //     instance.setOptions([
      //       {label: window.myvm.$gettext('d25 / DN20'), value: 0},
      //       {label: window.myvm.$gettext('d32 / DN25'), value: 1},
      //       {label: window.myvm.$gettext('d40 / DN32'), value: 2},
      //       {label: window.myvm.$gettext('d50 / DN40'), value: 3},
      //       {label: window.myvm.$gettext('d63 / DN50'), value: 4},
      //       {label: window.myvm.$gettext('d75 / DN63'), value: 5},
      //       {label: window.myvm.$gettext('d90 / DN80'), value: 6},
      //       {label: window.myvm.$gettext('d110 / DN100'), value: 7},
      //       {label: window.myvm.$gettext('d125 / DN110'), value: 8},
      //       {label: window.myvm.$gettext('d160 / DN150'), value: 9},
      //       {label: window.myvm.$gettext('d225 / DN200'), value: 10},
      //       {label: window.myvm.$gettext('d315 / DN250'), value: 11},
      //       {label: window.myvm.$gettext('d355 / DN300'), value: 12},
      //     ]);
      //   }
      // }


      if (matMetal != -1) {
        for (var i = 0; i < dim.length; ++i) {
          // console.log(matPlastic);
          if (values[matMetal][0][i] != 0 ) {
            dimsToAdd.push({label: window.myvm.$gettext(dim[i]), value: i});
          }
        }
        // that.$refs.selectMetalDimension.setOptions(dimsToAdd);
      } else {
        if (that.$refs.selectMaterialMetal.val() != "Stainless Steel") {
          // that.$refs.selectMetalDimension.setOptions([
          //   {label: window.myvm.$gettext('d25 / DN20'), value: 0},
          //   {label: window.myvm.$gettext('d32 / DN25'), value: 1},
          //   {label: window.myvm.$gettext('d40 / DN32'), value: 2},
          //   {label: window.myvm.$gettext('d50 / DN40'), value: 3},
          //   {label: window.myvm.$gettext('d63 / DN50'), value: 4},
          //   {label: window.myvm.$gettext('d75 / DN63'), value: 5},
          //   {label: window.myvm.$gettext('d90 / DN80'), value: 6},
          //   {label: window.myvm.$gettext('d110 / DN100'), value: 7},
          //   {label: window.myvm.$gettext('d125 / DN110'), value: 8},
          //   {label: window.myvm.$gettext('d160 / DN150'), value: 9},
          //   {label: window.myvm.$gettext('d225 / DN200'), value: 10},
          //   {label: window.myvm.$gettext('d250 / DN225'), value: 11},
          //   {label: window.myvm.$gettext('d315 / DN250'), value: 12},
          //   {label: window.myvm.$gettext('d355 / DN300'), value: 13},
          //   {label: window.myvm.$gettext('d400 / DN350'), value: 14},
          //   {label: window.myvm.$gettext('d450 / DN400'), value: 15},
          //   {label: window.myvm.$gettext('d500 / DN450'), value: 16},
          //   {label: window.myvm.$gettext('d560 / DN500'), value: 17},
          //   {label: window.myvm.$gettext('d630 / DN560'), value: 18},
          //   {label: window.myvm.$gettext('d710 / DN600'), value: 19},
          //   {label: window.myvm.$gettext('d800 / DN710'), value: 20},
          //   {label: window.myvm.$gettext('d900 / DN800'), value: 21},
          //   {label: window.myvm.$gettext('d1000 / DN900'), value: 22},
          // ]);
        } else {
          // that.$refs.selectMetalDimension.setOptions([
          //   {label: window.myvm.$gettext('d25 / DN20'), value: 0},
          //   {label: window.myvm.$gettext('d32 / DN25'), value: 1},
          //   {label: window.myvm.$gettext('d40 / DN32'), value: 2},
          //   {label: window.myvm.$gettext('d50 / DN40'), value: 3},
          //   {label: window.myvm.$gettext('d63 / DN50'), value: 4},
          //   {label: window.myvm.$gettext('d75 / DN63'), value: 5},
          //   {label: window.myvm.$gettext('d90 / DN80'), value: 6},
          //   {label: window.myvm.$gettext('d110 / DN100'), value: 7},
          //   {label: window.myvm.$gettext('d125 / DN110'), value: 8},
          //   {label: window.myvm.$gettext('d160 / DN150'), value: 9},
          //   {label: window.myvm.$gettext('d225 / DN200'), value: 10},
          //   {label: window.myvm.$gettext('d315 / DN250'), value: 11},
          //   {label: window.myvm.$gettext('d355 / DN300'), value: 12},
          // ]);
        }
      }


      if (matPlastic != -1) {
        for (var i = 0; i < dim.length; ++i) {
          // console.log(matPlastic);
          if (values[matPlastic][0][i] != 0 ) {
            dimsToAdd.push({label: window.myvm.$gettext(dim[i]), value: i});
          }
        }

        // that.$refs.selectPlasticDimension.setOptions(dimsToAdd);

      } else {
        // that.$refs.selectPlasticDimension.setOptions([
        //   {label: window.myvm.$gettext('d25 / DN20'), value: 0},
        //   {label: window.myvm.$gettext('d32 / DN25'), value: 1},
        //   {label: window.myvm.$gettext('d40 / DN32'), value: 2},
        //   {label: window.myvm.$gettext('d50 / DN40'), value: 3},
        //   {label: window.myvm.$gettext('d63 / DN50'), value: 4},
        //   {label: window.myvm.$gettext('d75 / DN63'), value: 5},
        //   {label: window.myvm.$gettext('d90 / DN80'), value: 6},
        //   {label: window.myvm.$gettext('d110 / DN100'), value: 7},
        //   {label: window.myvm.$gettext('d125 / DN110'), value: 8},
        //   {label: window.myvm.$gettext('d160 / DN150'), value: 9},
        //   {label: window.myvm.$gettext('d225 / DN200'), value: 10},
        //   {label: window.myvm.$gettext('d250 / DN225'), value: 11},
        //   {label: window.myvm.$gettext('d315 / DN250'), value: 12},
        //   {label: window.myvm.$gettext('d355 / DN300'), value: 13},
        //   {label: window.myvm.$gettext('d400 / DN350'), value: 14},
        //   {label: window.myvm.$gettext('d450 / DN400'), value: 15},
        //   {label: window.myvm.$gettext('d500 / DN450'), value: 16},
        //   {label: window.myvm.$gettext('d560 / DN500'), value: 17},
        //   {label: window.myvm.$gettext('d630 / DN560'), value: 18},
        //   {label: window.myvm.$gettext('d710 / DN600'), value: 19},
        //   {label: window.myvm.$gettext('d800 / DN710'), value: 20},
        //   {label: window.myvm.$gettext('d900 / DN800'), value: 21},
        //   {label: window.myvm.$gettext('d1000 / DN900'), value: 22},
        // ]);
      }

      this.calcResult();
    },
    onAddPipe() {
      var that = this;
      var ComponentClass = Vue.extend(Multiselect)
      var instance = new ComponentClass({
        propsData: {ref: "multiref", type: 'primary', id: "blub", placeholder: "lulu"}
      })
      instance.placeholder = "placeholdertest";
      instance.onChangeSelect = function (el) {
        that.onChangePlasticDimension(this);
        that.calcResult();
        instance.externalChange();
      };

      var instanceMetal = new ComponentClass({
        propsData: {ref: "multiref", type: 'primary', id: "blub", placeholder: "lulu"}
      })
      instanceMetal.placeholder = "placeholdertest";
      instanceMetal.onChangeSelect = function (el) {
        that.calcResult();
        instanceMetal.externalChange();
      };

      let dimsToAdd = [];
      let dim = dims;
      if (that.$refs.selectUnits.val() === "imperial") {
        dim = dimsImperial;
      }
      let matMetal = that.$refs.selectMaterialMetal.val();
      let matPlastic = that.$refs.selectMaterialPlastic.val();
      console.log("matPlastic", matPlastic);
      console.log("matMetal", matMetal);

      if (matPlastic != -1 && matMetal != -1 && matPlastic != "" && matMetal != "") {
        for (var i = 0; i < dim.length; ++i) {

          console.log(dim[i]);
          console.log(matMetal);
          console.log(matPlastic);
          console.log(values[matMetal][0][i]);
          console.log(values[matPlastic][0][i]);

          console.log("==================");
          if (dim[i] != 0 && values[matMetal][0][i] != 0 && values[matPlastic][0][i] != 0) {
            dimsToAdd.push({label: window.myvm.$gettext(dim[i]), value: i});
          }
        }
        instance.setOptions(dimsToAdd);
        dimsToAdd = [];
        for (var i = 0; i < dimsImperial.length; ++i) {
          if (dimsImperial[i] != 0 && values[matMetal][0][i] != 0 && values[matPlastic][0][i] != 0) {
            dimsToAdd.push({label: window.myvm.$gettext(dimsImperial[i]), value: i});
          }
        }
        console.log("dims", dimsToAdd);
        console.log("window.pipeListInstances",window.pipeListInstances);
        instanceMetal.setOptions(dimsToAdd);
        // for (var i = 0; i < window.pipeListInstances.length; ++i) {
        //   console.log("add dims " + dimsToAdd);
        //   instance.setOptions(dimsToAdd);
        // }
      } else {
        if (that.$refs.selectMaterialMetal.val() != "Stainless Steel") {
          instance.setOptions([
            {label: window.myvm.$gettext('d25 / DN20'), value: 0},
            {label: window.myvm.$gettext('d32 / DN25'), value: 1},
            {label: window.myvm.$gettext('d40 / DN32'), value: 2},
            {label: window.myvm.$gettext('d50 / DN40'), value: 3},
            {label: window.myvm.$gettext('d63 / DN50'), value: 4},
            {label: window.myvm.$gettext('d75 / DN63'), value: 5},
            {label: window.myvm.$gettext('d90 / DN80'), value: 6},
            {label: window.myvm.$gettext('d110 / DN100'), value: 7},
            {label: window.myvm.$gettext('d125 / DN110'), value: 8},
            {label: window.myvm.$gettext('d160 / DN150'), value: 9},
            {label: window.myvm.$gettext('d225 / DN200'), value: 10},
            {label: window.myvm.$gettext('d250 / DN225'), value: 11},
            {label: window.myvm.$gettext('d315 / DN250'), value: 12},
            {label: window.myvm.$gettext('d355 / DN300'), value: 13},
            {label: window.myvm.$gettext('d400 / DN350'), value: 14},
            {label: window.myvm.$gettext('d450 / DN400'), value: 15},
            {label: window.myvm.$gettext('d500 / DN450'), value: 16},
            {label: window.myvm.$gettext('d560 / DN500'), value: 17},
            {label: window.myvm.$gettext('d630 / DN560'), value: 18},
            {label: window.myvm.$gettext('d710 / DN600'), value: 19},
            {label: window.myvm.$gettext('d800 / DN710'), value: 20},
            {label: window.myvm.$gettext('d900 / DN800'), value: 21},
            {label: window.myvm.$gettext('d1000 / DN900'), value: 22},
          ]);
        } else {
          instance.setOptions([
            {label: window.myvm.$gettext('d25 / DN20'), value: 0},
            {label: window.myvm.$gettext('d32 / DN25'), value: 1},
            {label: window.myvm.$gettext('d40 / DN32'), value: 2},
            {label: window.myvm.$gettext('d50 / DN40'), value: 3},
            {label: window.myvm.$gettext('d63 / DN50'), value: 4},
            {label: window.myvm.$gettext('d75 / DN63'), value: 5},
            {label: window.myvm.$gettext('d90 / DN80'), value: 6},
            {label: window.myvm.$gettext('d110 / DN100'), value: 7},
            {label: window.myvm.$gettext('d125 / DN110'), value: 8},
            {label: window.myvm.$gettext('d160 / DN150'), value: 9},
            {label: window.myvm.$gettext('d225 / DN200'), value: 10},
            {label: window.myvm.$gettext('d315 / DN250'), value: 11},
            {label: window.myvm.$gettext('d355 / DN300'), value: 12},
          ]);
        }
      }
      instance.setSelectedIndex(0);
      instance.$mount();
      that.$refs.pipesList.appendChild(instance.$el);

      instanceMetal.$mount();
      // that.$refs.pipesListMetal.appendChild(instanceMetal.$el);

      var unit = window.myvm.$gettext('m');
      if (that.$refs.selectUnits.val() === "imperial") {
        unit = window.myvm.$gettext('feet');
      }

      if (pipeListCounter === 0) {
        $("#pipesList").append('<div class="pipeListItem" id="pipeList' + pipeListCounter + '" data-pipelistid="' + pipeListCounter + '"><div class="ddWrapper ddWrapperPipe">' + window.myvm.$gettext('Plastic <br>Pipe Dimension') + '</div><div class="ddWrapperMetal ddWrapperPipe">' + window.myvm.$gettext('Metal<br>Pipe Dimension') + '</div><div class="inputLengthWrapper">' + window.myvm.$gettext('<br>Length') + ' (<span class="unitM">' + unit + '</span>)<input type="number" class="inputLength" value="0" onchange="that.calcResult()"> </div></div>');
      } else {
        let papierkorb = $("#imgPapierkorb").attr("src");
        $("#pipesList").append('<div class="pipeListItem" id="pipeList' + pipeListCounter + '" data-pipelistid="' + pipeListCounter + '"><div class="ddWrapper ddWrapperPipe">' + window.myvm.$gettext('Plastic <br>Pipe Dimension') + '</div><div class="ddWrapperMetal ddWrapperPipe">' + window.myvm.$gettext('Metal<br>Pipe Dimension') + '</div><div class="inputLengthWrapper">' + window.myvm.$gettext('<br>Length') + ' (<span class="unitM">' + unit + '</span>)<input type="number" class="inputLength" value="0" onchange="that.calcResult()"> </div><img onclick="deletePipe(this)" class="papierkorb" src="' + papierkorb + '"></div>');
      }

      // if (pipeListCounter === 0) {
      //   $("#pipesList").append('<div class="pipeListItem" id="pipeList' + pipeListCounter + '" data-pipelistid="' + pipeListCounter + '"><div class="inputLengthWrapper">' + window.myvm.$gettext('Length') + ' (<span class="unitM">' + unit + '</span>)<input type="number" class="inputLength" value="0" onchange="that.calcResult()"> </div></div>');
      // } else {
      //   let papierkorb = $("#imgPapierkorb").attr("src");
      //   $("#pipesList").append('<div class="pipeListItem" id="pipeList' + pipeListCounter + '" data-pipelistid="' + pipeListCounter + '"><div class="inputLengthWrapper">' + window.myvm.$gettext('Length') + ' (<span class="unitM">' + unit + '</span>)<input type="number" class="inputLength" value="0" onchange="that.calcResult()"> </div><img onclick="deletePipe(this)" class="papierkorb" src="' + papierkorb + '"></div>');
      // }


      $("#pipeList" + pipeListCounter + " .ddWrapper").append(instance.$el);
      $("#pipeList" + pipeListCounter + " .ddWrapperMetal").append(instanceMetal.$el);

      pipeListInstances.push(instance);
      window.pipeListInstances = pipeListInstances;
      $(instance.$el).attr('id', 'selectPlasticDim_'+pipeListInstances.length);
      $(instance.$el).attr('data-id', pipeListInstances.length);
      $(instance.$el).addClass('selectPlasticDim');

      pipeListInstancesMetal.push(instanceMetal);
      window.pipeListInstancesMetal = pipeListInstancesMetal;
      $(instanceMetal.$el).attr('id', 'selectMetalDim_'+pipeListInstancesMetal.length);
      $(instanceMetal.$el).attr('data-id', pipeListInstancesMetal.length);
      $(instanceMetal.$el).addClass('selectMetalDim');

      pipeListCounter++;
    },
    formatNumber(number) {
      return new Intl.NumberFormat(window.mylang).format(number);
    },
    doReset() {
      window.location.reload();
    },

  }
}
</script>
<style>
.badge {
  box-sizing: unset;
}
</style>
<style scoped>
@font-face {
  font-family: "DINNextLTW05-Regular";
  src: url("../assets/DINNextLTW05-Regular.eot?#iefix");
  src: url("../assets/DINNextLTW05-Regular.eot?#iefix") format("eot"),
  url("../assets/DINNextLTW05-Regular.woff2") format("woff2"),
  url("../assets/DINNextLTW05-Regular.woff") format("woff"),
  url("../assets/DINNextLTW05-Regular.ttf") format("truetype");
}

@font-face {
  font-family: "GlyphaLTW05-65Bold";
  src: url("../assets/GlyphaLTW05-65Bold.eot?#iefix");
  src: url("../assets/GlyphaLTW05-65Bold.eot?#iefix") format("eot"),
  url("../assets/GlyphaLTW05-65Bold.woff2") format("woff2"),
  url("../assets/GlyphaLTW05-65Bold.woff") format("woff"),
  url("../assets/GlyphaLTW05-65Bold.ttf") format("truetype");
}

@font-face {
  font-family: "DINNextLTW01-Medium";
  src: url("../assets/DINNextLTW01-Medium.eot?#iefix");
  src: url("../assets/DINNextLTW01-Medium.eot?#iefix") format("eot"),
  url("../assets/DINNextLTW01-Medium.woff2") format("woff2"),
  url("../assets/DINNextLTW01-Medium.woff") format("woff"),
  url("../assets/DINNextLTW01-Medium.ttf") format("truetype");
}

h3 {
  margin-top: 0;
  margin-bottom: 6px;
}

.mainWrapper {
  width: 90vw;
  margin-left: auto;
  margin-right: auto;
  max-width: 1280px;
}

.row {
  width: 100%;
  text-align: left;
}

.halfRow {
  width: 56%;
  text-align: left;
  display: inline-block;
  vertical-align: top;
}

.col50 {
  display: inline-block;
  width: 60%;
  margin-right: 4%;
  vertical-align: top;
}

.resultList {
  display: inline-block;
  width: 100%;
  margin-bottom: 20px;
  min-width: 342px;
}

.resultInfo {
  display: inline-block;
  vertical-align: top;
  width: 100%;
  /*margin-top: 20px;*/
}

.bAddPipe {
  border: 2px solid #00afff;
  color: #00afff;
  padding: 6px 30px;
  float: left;
  cursor: pointer;
  margin-top: 10px;
}

.resultMaterialHeader {
  font-weight: bold;
  margin-bottom: 5px;
}

.badge {
  height: 50px;
  padding: 20px;
  /*max-width:400px;*/
  background-repeat: no-repeat;
  background-position: top 10px right 20px;
  background-color: #00629B;
  background-size: 70px 70px;
}

.badgeCO2 {
  background-image: url("../assets/icon_co2.svg");
  background-color: #007A53 !important;
}

.badgeCar {
  background-image: url("../assets/icon_car.svg");
}

.badgePlane {
  background-image: url("../assets/icon_plane.svg");
}

.badgeLeaf {
  background-image: url("../assets/icon_leaf.svg");
}

.badgeHeader {
  display: flex;
  justify-items: center;
  color: #fff;
}

.badgeNumber {
  font-size: 25px;
  color: #fff;
  margin-top: 4px;
  font-family: "DINNextLTW01-Medium", Arial !important;
  font-weight: bold;
}

.infoI {
  margin-left: 5px;
  width: 20px;
  height: 20px;
  cursor: pointer;
}

.resultName {
  margin-top: 0px;
  margin-bottom: 5px;
}

.countResult {
  font-size: 25px;
  font-weight: bold;
}

.blueBadgeHeader {
  margin-left: 14px;
  margin-bottom: 2px;
}

.blueBadge {
  margin-bottom: 10px;
}
.withborder {
  padding:10px;
  border: solid 1px #666666;
  width:43%;
}
</style>
<style>
* {
  outline: none !important;
}

#app {
  font-family: "DINNextLTW05-Regular", Arial;
}

.pipeListItem {
  margin-top: 20px;
}

.ddWrapper, .ddWrapperMetal {
  width: 170px;
  text-align: left;
  display: inline-block;
  margin-right: 2%;
  margin-bottom: 10px;
  vertical-align: top;
}

.countryCO2 {
  /*margin-top:20px;*/
}

#selectCountryCO2 .multiselect {
  margin-top: 5px;
}

.inputLengthWrapper {
  display: inline-block;
  width:90px;
}

.inputLength {
  width: 100%;
  height: 2.5rem;
  border: 0;
  background: #f0f0f0;
  margin-top: 8px;
  padding: 0 0 0 4px;
}

.myTooltip {
  background-color: #fff;
  border: 1px solid #999;
  color: #000;
  font-family: "DINNextLTW05-Regular", Arial;
}

.papierkorb {
  margin-left: 12px;
  cursor: pointer;
  vertical-align: middle;
  background-image: url("../assets/papierkorb.png");
}

td {
  vertical-align: top;
}

@media all and (max-width: 1200px) {
  .resultList {
    width: 100% !important;
  }

  .resultInfo {
    width: 100% !important;
  }

  .halfRow {
    width: 100% !important;
    text-align: left;
    display: block;
    vertical-align: top;
  }
}

@media all and (max-width: 720px) {
  #app {
    margin: 0;
    width: 100%;
    /*overflow: hidden;*/
  }

  .ddWrapper, .ddWrapperMetal {
    width: 100%;
  }

  .ddWrapperPipe {
    //width: 62%;
  }
  .withborder {
    width:94%!important;
  }
  .col50 {
    width: 100% !important;
  }

  .resetDiv {
    margin-top: 0 !important;
  }

  .resultMaterialPlastic {
    /*margin-top:26px!important;*/
  }
}

p {
  margin: 0px
}

h1 {
  margin: 0px
}

h2 {
  margin: 0px
}

h3 {
  margin: 0px
}

</style>